module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-black-tie',\n    title: 'Share',\n    description: 'Send/share relevant material with others that help you out or those that you need to report to.'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/8-share/share.section-header.html
// module id = 4138
// module chunks = 86